<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Cash Winners</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>{{ lps() }}</b>
      /
      <router-link :to="{ name: 'cash-winner' }">Cash Winners</router-link>
      /
      <b>Add Event Winner</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div style="margin-bottom: 30px;"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">

            <br/>

            <div class="row mb-2">
              <div class="col-6 text-left">
                <h4 class="card-title mb-3">Add Event Winners</h4>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
                <label>Event Name</label>
                <div class="input-group d-flex flex-row p2">
                  <input type="input" class="form-control mr-5" v-model="event_name" />
                  <button type="button" class="btn btn-primary ml-4" @click="storeEvent">
                    Submit
                  </button>
                </div>
              </div>
            </div>

            <hr />

            <div class="row">
              <div class="col-12">
                <input
                  type="file"
                  id="excel_upload"
                  ref="file"
                  @change="excelUpload"
                  class="inputfile"
                />
              </div>
            </div>

            <hr />

            <div class="table-responsive">
              <h3 class="ml-1">
                <b>Selected Users</b>
              </h3>
              <table
                id="uploaded_users"
                class="display table table-striped table-bordered"
              >
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>IC Number</th>
                    <th>Mobile Number</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import dateManipulation from "@/mixins/dateManipulation";
import "vue-select/dist/vue-select.css";
import { postRequest } from "@/services/RequestService";
import readXlsxFile from "read-excel-file";

export default {
  name: "add-event-winner",
  mixins: [dateManipulation],
  components: {  },

  data() {
    return {
      data: {
        account_number: '000000',
        name: '',
        email: '',
        phone_number: ''
      },
      user_id: null,
      ic_number: null,
      point: 0,
      description: '',
      fileUploaded: null,
      event_name: null

    };
  },

  methods: {
    async getUserAccountNumber() {
      try {
        let res = await postRequest(axios.lpsURL +`/award/check_user`, {ic_number: this.ic_number});
        this.data = res.data.success ? res.data.data : {account_number: 'Not Found', name: 'Not Found', email: 'Not Found', phone_number: 'Not Found'};
        this.user_id = res.data.success ? res.data.data.user_id : null;
      } catch (e) {
        console.log(e)
      }
    },

    async storeEvent() {
      if(this.event_name == null || this.event_name == '') {
        return swal ({
          icon: 'error',
          title: 'Failed',
          text: 'Please enter event name.'
        })
      }

      if (document.getElementById("excel_upload").files.length == 0) {
        swal({
          title: "Failed",
          icon: "error",
          text: "Please upload a file before submitting.",
        });

        return;
      }

      try {
        let formData = new FormData();
        formData.append("fileUploaded", this.fileUploaded);
        formData.append("name", this.event_name);

        let res = await postRequest(`loyalty/prize`, formData);

        swal({
          title: res.data.success ? 'Success' : 'Failed',
          icon: res.data.success ? 'success' : 'error',
          text: res.data.message
        });

        if(res.data.success) {
          this.$router.push('/lps/cash-winner')
        }
      } catch (e) {
        console.log(e)
      }
    },

    postRequest() {
      return {
        user_id: this.user_id,
        description: this.description,
        point: this.point
      }
    },

    reset() {
      this.user_id = null;
      this.account_number = '000000'
    },

    excelUpload(e) {
      this.fileUploaded = this.$refs.file.files[0];
      const input = document.getElementById("excel_upload");
      let table = $("#uploaded_users").find("tbody");

      // Clear table
      $("#uploaded_users tbody tr").remove();

      readXlsxFile(input.files[0]).then((rows) => {
        let data;
        rows.shift();
        rows.forEach((array, key1) => {
          data = "<tr>";

          array.forEach((element, key) => {
            data += "<td>" + element + "</td>";
          });

          data += "</tr>";

          table.append(data);
        });

        this.loadTable();
      });
    },

    loadTable() {
      $("#uploaded_users").DataTable({
        dom: "frtip",
        pageLength: 20,
      });
    },

    lps() {
      return this.$lps();
    }
  },
};
</script>

<style scoped>
input[type="file"]::file-selector-button {
  margin-right: 20px;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  color: #fff;
  background-color: #AC8400;
  border-color: #AC8400;

  /* cursor: pointer; */
  transition: background 0.2s ease-in-out;
}

input[type="file"]::file-selector-button:hover {
  color: #fff;
    background-color: #806200;
    border-color: #b38900;
}
</style>
